module.exports = __webpack_public_path__ + "img/LFGB-logo.23741c54.png";